
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as health5nzBvjxenRORbLPQH5Hkk14ysGV2i0J8x4ikmG2NfmoMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/jetpark/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_939JBMKRWd9bdxD5BIx7seJU5Mq2aY3Hz_45HXUS_smMIAYMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/packages/base/pages/[...slug].vue?macro=true";
import { default as component_45stub26lPXVAan__45OGD6y1aHJsfzNHku7ypekj4o_dHoFicEMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.7.0_db0@0.3.4_eslint@9.37.0_jiti@1.21._4b8b6c88da3108ad874f2c506e8c7f7d/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub26lPXVAan__45OGD6y1aHJsfzNHku7ypekj4o_dHoFicE } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.7.0_db0@0.3.4_eslint@9.37.0_jiti@1.21._4b8b6c88da3108ad874f2c506e8c7f7d/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/jetpark/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/packages/base/pages/[...slug].vue")
  },
  {
    name: component_45stub26lPXVAan__45OGD6y1aHJsfzNHku7ypekj4o_dHoFicEMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub26lPXVAan__45OGD6y1aHJsfzNHku7ypekj4o_dHoFicE
  }
]